module.exports = __webpack_public_path__ + "assets/7ab6f6ad6845b7715ec77b1e6f062a2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/channels/bg/1.png
// module id = 360
// module chunks = 1